import Checkbox from "antd/es/checkbox";
import {TeamManagement} from "components/TeamManagement";
export const TeamManagementPopup = ({user, setNeverAsk, neverAskCheck})=>{
  return <div>
    <h3>Invite and collaborate with your friends on common projects</h3>
    <TeamManagement user={user} source="dashboard"/>
    <br/>
    <Checkbox checked={neverAskCheck} onChange={(e)=>{setNeverAsk(e.target.checked)}}>Never ask again</Checkbox>
  </div>
}